export default (superClass) => {
    return class extends superClass {
        get minAmount() {
            return this._data.amount_from;
        }

        get maxAmount() {
            return this._data.amount_to;
        }
        
        get maxAmountToExistingCustomers() {
            return this._data.amount_to_existing_customers;
        }

        get minAmountString() {
            return this.formatCurrency(this.minAmount); 
        }

        get maxAmountString() {
            return this.formatCurrency(this.maxAmount);
        }

        get amountString() {

            if(this.minAmount == this.maxAmount) {
                return this.minAmountString;
            }

            return this.formatCurrencyRange(this.minAmount, this.maxAmount);
        }

        get hasExtraLoanAmountToExistingCustomers() {
            return this.maxAmountToExistingCustomers && 
                this.maxAmountToExistingCustomers > 0;
        }

        get maxAmountToExistingCustomersString() {
            return this.formatCurrency(this.maxAmountToExistingCustomers);
        }

        getMaxAmountToExistingCustomersString(template = 'Upp till {amount} till existerande kunder') {
            return template.replace('{amount}', this.maxAmountToExistingCustomersString);
        }
    }
}